import { render, staticRenderFns } from "./AppCustomizer.vue?vue&type=template&id=8fd49a92&scoped=true&"
import script from "./AppCustomizer.vue?vue&type=script&lang=js&"
export * from "./AppCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./AppCustomizer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AppCustomizer.vue?vue&type=style&index=1&id=8fd49a92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd49a92",
  null
  
)

export default component.exports